var _style, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBlueSphere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3.9 3.9",
    style: {
      enableBackground: "new 0 0 3.9 3.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 2.448,
    cy: 1.4063,
    r: 2.7057,
    fx: 3.3222,
    fy: 0.6584,
    gradientTransform: "matrix(1 0 0 0.9308 0 9.737101e-02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    style: {
      stopColor: "#00F1F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3858,
    style: {
      stopColor: "#0DCCE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    style: {
      stopColor: "#2D75BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3952AE"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1.9,
    cy: 1.9,
    r: 1.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBlueSphere);
export default __webpack_public_path__ + "static/media/light-blue-sphere.1ff45dad7b498e959053342c13539c79.svg";
export { ForwardRef as ReactComponent };